import React from 'react';
import { Column, Spinner, TextCaption } from '@scotia/canvas-react';
import PropTypes from 'prop-types';

export const validateSimpleAccountRegistry = (simpleAccountNumber, accountKey) => {
  try {
    return (
      simpleAccountNumber &&
      simpleAccountNumber[accountKey] &&
      simpleAccountNumber[accountKey].currentSimpleAccount &&
      simpleAccountNumber[accountKey].originalAccountNumber
    );
  } catch (e) {
    return false;
  }
};
export const DefaultToolTipText = ({ children, isRedClient }) => (
  <div>
    {isRedClient && (
      <div>
        <TextCaption className="text--light">
          Aquí podrás acceder a todos tus fondos, depositar y revisar posteriormente tus montos disponibles.
        </TextCaption>
      </div>
    )}
    {children}
  </div>
);

const formatBlueAccountNumber = rawBlueAccountNumber =>
  rawBlueAccountNumber
    .toString()
    .padStart(18, '0')
    .replace(/(\d{4})(\d{4})(\d{10})/, '$1-$2-$3');

export const ToolTipText = ({ isRedClient, simpleAccountNumber, accountKey }) => {
  const hasValidSimpleAccount = validateSimpleAccountRegistry(simpleAccountNumber, accountKey);
  if (typeof isRedClient === 'undefined' || (!isRedClient && !hasValidSimpleAccount))
    return (
      <Column>
        <DefaultToolTipText isRedClient={isRedClient}>
          <Spinner color={'highlight'} size={24} />
        </DefaultToolTipText>
      </Column>
    );
  if (simpleAccountNumber && hasValidSimpleAccount)
    return (
      <Column>
        <DefaultToolTipText isRedClient={isRedClient}>
          <TextCaption className="text--light">Tus números anteriores siguen operando de forma normal:</TextCaption>
          <br />
          <TextCaption className="text--roman">- {simpleAccountNumber[accountKey].currentSimpleAccount}</TextCaption>
          <TextCaption className="text--roman">
            - {formatBlueAccountNumber(simpleAccountNumber[accountKey].originalAccountNumber)}
          </TextCaption>
        </DefaultToolTipText>
      </Column>
    );
  if (isRedClient)
    return (
      <div>
        <TextCaption className="text--light">
          Aquí podrás acceder a todos tus fondos, depositar y revisar posteriormente tus montos disponibles.
        </TextCaption>
      </div>
    );
  return <React.Fragment />;
};
ToolTipText.propTypes = {
  isRedClient: PropTypes.bool,
  simpleAccountNumber: PropTypes.object,
  accountKey: PropTypes.string,
};

ToolTipText.defaultProps = {
  isRedClient: undefined,
  simpleAccountNumber: undefined,
  accountKey: undefined,
};

export default ToolTipText;
